import React from "react";
import PrefTable from "./PrefTable";
import _ from 'lodash';
import CreateTableRows from "./CreateTableRows";
import TablePaginationHelper from "../../../utils/tablePaginationHelper";

class ControlledLoanPrefTable extends React.Component {
  state = {
    orderDir: "asc",
    orderBy: "createdAt",
    selected: []
  };

  tablePaginationHelper = new TablePaginationHelper(this.props.tableConfigItemId, 10, this.props.dealId);

  callbacks = {
    'expired': () => {
      this.props.setExpired(true)
    },
    getDealId: () => this.props.dealId
  }

  // BEGIN: Table Controls
  handleRequestSort = (event, property) => {
    const orderBy = property.dataField;
    let order = "desc";
    if (orderBy) {
      if (
        this.state.orderBy === property.dataField &&
        this.state.orderDir === "desc"
      ) {
        order = "asc";
      }

      this.setState({         
        orderDir: order.toLowerCase(), 
        orderBy
      });
      this.tablePaginationHelper.page = 0;
      this.props.updateTableState({
        sortOrder: { 
          orderDir: order.toLowerCase(), 
          orderBy, 
          page: this.tablePaginationHelper.page
        } 
      })  
    }
  };

  handleChangePage = (event, newPage) => {
    if (!event) {
      return null;
    }        
    this.tablePaginationHelper.page = newPage;
    this.props.updateTableState({ page: this.tablePaginationHelper.page, pageSize: this.tablePaginationHelper.rowsPerPage });
  };

  handleChangeRowsPerPage = event => {
    this.tablePaginationHelper.rowsPerPage = event.target.value;
    this.props.updateTableState({ page: this.tablePaginationHelper.page, pageSize: this.tablePaginationHelper.rowsPerPage });
  };

  render() {    
    const { screenPreferences, shouldHideConfig, dealId,callbacks } = this.props;
    if(_.isEmpty(screenPreferences))
      return null;
    if(_.isEmpty(this.props.tableData))
      return null;    
    const tableSettings = {
      tableData: this.props.tableData,
      dataMap: data => data.loans.length > 0 ? data.loans : data.loanData,
      getCount: tableData => tableData.data.count,
      orderDir: this.state.orderDir,
      orderBy: this.state.orderBy,
      selected: this.state.selected,
      rowsPerPage: this.tablePaginationHelper.rowsPerPage,
      page: this.tablePaginationHelper.page
    };
    //required from client code:
    // screenPreferences
    // screenType
    // tableScreenElements
    return (
      <PrefTable      
        shouldHideConfig={shouldHideConfig}
        tableClasses = ""
        tableSettings={tableSettings}
        screenPreferences={screenPreferences}
        screenType={this.props.screenType}
        tableLabel={this.props.tableLabel}
        handleRequestSort={this.handleRequestSort}
        handleChangePage={this.handleChangePage}
        handleChangeRowsPerPage={this.handleChangeRowsPerPage}
        TableScreenElements={this.props.tableScreenElements}
        getRows={CreateTableRows}
        callbacks={this.callbacks}
        dealId={dealId}
        exportTable={this.props.downloadLoans}
        tableId="controledLoan"
      />
    );
  }
}

export default ControlledLoanPrefTable;
